(function announcementBar() {
  const c = {
    dom: {
      main: '[data-announcement-bar]',
      btn: '[data-announcement-bar-close]'
    },
    cls: {
      hide: 'hide'
    },
  };
  const $main = document.querySelector(c.dom.main);
  const $btn = document.querySelector(c.dom.btn);

  function init() {
    if (!$main || !$btn) return;
    document.body.classList.add('announcement-bar-open');
    $btn.addEventListener('click', () => {
      $main.classList.add(c.cls.hide);
      document.body.classList.remove('announcement-bar-open');
    })
  };

  return init();
})();